import { DocumentNode, gql } from '@apollo/client';
import { Avatar, BoxProps, HStack, Stack, Text } from '@chakra-ui/react';
import * as React from 'react';

import { CompositeJobCompany } from '@/components/CompositeJobCompany';
import { Card } from '@/imports/ui/chakra/components/Card';

import { SpeakerCard_UserFragment } from './graphql-types/SpeakerCard_UserFragment';

export const SpeakerCard: React.FC<
  {
    user: SpeakerCard_UserFragment;
  } & BoxProps
> & { userFragment: DocumentNode } = ({ user, ...props }) => {
  return (
    <Card
      p="4"
      h="20"
      shadow="xs"
      cursor="pointer"
      _hover={{
        bg: 'gray.50',
      }}
      {...props}
    >
      <HStack spacing="4">
        <Avatar
          src={user.proxyProfilePictureUrl ?? undefined}
          name={user.displayName}
        />
        <Stack spacing="0">
          <Text textStyle="bodyStrong" noOfLines={1}>
            {user.displayName}
          </Text>
          <Text noOfLines={1}>
            <CompositeJobCompany
              jobTitle={user.jobTitle}
              company={user.company}
            />
          </Text>
        </Stack>
      </HStack>
    </Card>
  );
};

SpeakerCard.userFragment = gql`
  fragment SpeakerCard_UserFragment on User {
    _id
    displayName
    jobTitle
    company
    proxyProfilePictureUrl(
      input: { w: 140, h: 140, fit: "facearea", facepad: 10.0 }
    )
  }
`;
